<template>
  <div id="grid-dia-regular">
    <v-container grid-list-xl fluid>
      <!-- dsoto  21-12-2022-->

      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-select
              v-model="periodoValue"
              :items="periodoSelect"
              label="Periodo"
              data-vv-name="listaPeriodos"
            ></v-select>
          </v-flex>

          <v-flex xs12 md3>
            <v-select
              v-model="nivelValue"
              :items="nivelSelect"
              item-text="name"
              item-value="code"
              label="Nivel"
            ></v-select>
          </v-flex>

          <v-flex xs12 md4>
            <v-select
              v-model="proveedorValue"
              :items="proveedorSelect"
              label="Proveedor"
              item-text="nombre"
              item-value="code"
            ></v-select>
          </v-flex>

          <v-btn
            fab
            dark
            color="teal"
            title="Filtrar detalle"
            @click="filtro()"
          >
            <v-icon dark>filter_list</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="red darken-4"
            title="Limpiar filtros"
            @click="clear()"
          >
            <v-icon dark>clear_all</v-icon>
          </v-btn>
        </v-layout>
      </v-container>

      <!-- dsoto  21-12-2022  -->

      <!--
      <v-layout justify-center>
        <v-flex xs12 md3> 
            <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="name"
            item-value="code"
            label="Nivel"
          ></v-select>  
        </v-flex>
        <v-btn fab dark color="teal" title="Filtrar detalle" @click="filtro()">
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn fab dark color="red darken-4" title="Limpiar filtros" @click="clear()">
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      -->

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <v-spacer></v-spacer>
          <v-toolbar v-if="graficaRegular == true" card color="white">
            <v-toolbar-title class="indigo--text"
              >Resumen De Cobertura de Aplicación Cursos DS</v-toolbar-title
            >
          </v-toolbar>
          <template v-if="graficaRegular == true">
            <v-data-table
              :headers="headers3"
              :items="itemsDs"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              @page-count="pageCount = $event"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.region }}</td>
                <td class="text-xs-left">
                  {{ props.item.totalEstablecimientos }}
                </td>
                <td class="text-xs-left">{{ props.item.estAplicados }}</td>
                <td class="text-xs-left">
                  {{ props.item.estEmergentesAplicados }}
                </td>
                <td class="text-xs-left">{{ props.item.estNoAplicados }}</td>
                <td class="text-xs-left">{{ props.item.totalCursos }}</td>
                <td class="text-xs-left">{{ props.item.cursosAplicados }}</td>
                <td class="text-xs-left">{{ props.item.curEmergAplicados }}</td>
                <td class="text-xs-left">{{ props.item.curNoAplicados }}</td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-toolbar v-if="graficaRegular == true" card color="white">
            <v-toolbar-title class="indigo--text">Cursos DS</v-toolbar-title>
          </v-toolbar>
          <template v-if="graficaRegular == true">
            <v-data-table
              :headers="headers"
              :items="itemsDs"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              @page-count="pageCount = $event"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.region }}</td>
                <td class="text-xs-left">{{ props.item.estAplicados }}</td>
                <td class="text-xs-left">
                  {{ props.item.estEmergentesAplicados }}
                </td>
                <td class="text-xs-left">{{ props.item.estNoAplicados }}</td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
    <grafica-dia-rbd-ds
      v-if="graficaRegular == true"
      :nivel="nivelValue"
      :show="true"
      :nivelNombre="this.nivelName()"
      :periodo="periodoValue"
      :proveedor="proveedorValue"
    ></grafica-dia-rbd-ds>
    <v-container>
      <v-toolbar v-if="graficaRegular == true" card color="white">
        <v-toolbar-title class="indigo--text"
          >Curso Aplicacion Ds</v-toolbar-title
        >
      </v-toolbar>
      <template v-if="graficaRegular == true">
        <v-data-table
          :headers="headers"
          :items="itemsDs"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          @page-count="pageCount = $event"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.region }}</td>
            <td class="text-xs-left">{{ props.item.cursosAplicados }}</td>
            <td class="text-xs-left">{{ props.item.curEmergAplicados }}</td>
            <td class="text-xs-left">{{ props.item.curNoAplicados }}</td>
          </template>
        </v-data-table>
      </template>

      <!-- dsoto  28-12-2022-->
      <grafica-curso-ds
        v-if="graficaRegular == true"
        :show="true"
        :nivel="nivelValue"
        :nivelNombre="this.nivelName()"
        :periodo="periodoValue"
        :proveedor="proveedorValue"
      ></grafica-curso-ds>

      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="botonDescarga == true"
          color="primary"
          @click="downloadData()"
          >Descarga</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import GraficaDiaRbdDs from "@/modules/configuration/reporteria/views/GraficaDiaRbdDs.vue";
import GraficaCursoDs from "@/modules/configuration/reporteria/views/GraficaCursoDs.vue";

export default {
  name: "dia-DS",

  components: {
    Loading,
    GraficaDiaRbdDs,
    GraficaCursoDs,
  },
  props: {},

  data() {
    return {
      graficaRegular: false,
      nivelValue: "",
      nivelSelect: [],
      loading: false,
      id: "",
      totalRegistro: "",
      rowsPerPageItems: [50],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalPages: 0,
      totalRegistros: "",
      idContrato: "",
      headers: [
        { text: "Region", align: "left", sortable: false, value: "rut" },
        {
          text: "Establecimiento Aplicados",
          sortable: false,
          value: "candidato",
        },
        { text: "Emergentes Aplicados", sortable: false, value: "evaluacion" },
        { text: "No Aplicados", sortable: false, value: "fecha" },
      ],
      headers2: [
        { text: "Region", align: "left", sortable: false, value: "rut" },
        { text: "Cursos Aplicados", sortable: false, value: "candidato" },
        { text: "Emergentes Aplicados", sortable: false, value: "evaluacion" },
        { text: "No Aplicados", sortable: false, value: "fecha" },
      ],
      headers3: [
        { text: "Region", align: "left", sortable: false, value: "rut" },
        {
          text: "Total Establecimientos",
          align: "left",
          sortable: false,
          value: "rut",
        },
        { text: "Est Aplicados", align: "left", sortable: false, value: "rut" },
        {
          text: "Est Emerg Aplicados",
          align: "left",
          sortable: false,
          value: "rut",
        },
        {
          text: "Est No Aplicados",
          align: "left",
          sortable: false,
          value: "rut",
        },
        { text: "Total Cursos", align: "left", sortable: false, value: "rut" },
        { text: "Cursos Aplicados", sortable: false, value: "candidato" },
        { text: "Emergentes Aplicados", sortable: false, value: "evaluacion" },
        { text: "Cursos No Aplicados", sortable: false, value: "fecha" },
      ],
      usuarioLoggedTipe: "",
      itemsDs: [],
      idUserLogged: "",
      proceso: "",

      // 21-12-2022
      periodoSelect: [],
      periodoValue: null,
      proveedorSelect: [],
      proveedorValue: null,
      itemsProveedor: [],
      botonDescarga: false,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;

    // dsoto 21-12-2022

    this.periodoValue = new Date().getFullYear();
    for (let i = parseInt(2019); i <= parseInt(this.periodoValue); i++) {
      this.periodoSelect.push(i);
    }
    this.proveedores();
    // dsoto 21-12-2022

    this.loadDataNiveles();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadDsFilter() {
      //alert("DSProv");
      if (
        this.periodoValue != null &&
        this.proveedorValue != null &&
        this.nivelValue != null
      ) {
        return await axios
          .get(
            "/reportes/diaAplicacion/DSProv/" +
              this.nivelValue +
              "/" +
              this.periodoValue +
              "/" +
              this.proveedorValue
          )
          .then(function (response) {
            return response.data;
          })
          .catch((error) => {
            if (error) {
              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        if (this.periodoValue != null && this.nivelValue != null) {
          return await axios
            .get(
              "/reportes/diaAplicacion/DS/" +
                this.nivelValue +
                "/" +
                this.periodoValue
            )
            .then(function (response) {
              return response.data;
            })
            .catch((error) => {
              if (error) {
                console.log(error.response.data);
                window.getApp.$emit(
                  "ERROR_EXCEPTION",
                  error.response.data.message
                );
              }
              return [];
            });
        } else {
          return [];
        }
      }
    },
    async loadData() {
      this.loading = true;
      this.botonDescarga = false;
      this.graficaRegular = false;
      this.itemsDs = await this.loadDsFilter();

      if (this.itemsDs.length > 0) {
        this.botonDescarga = true;
        this.graficaRegular = true;
      } else {
        this.graficaRegular = false;
      }
      this.loading = false;
    },

    filtro() {
      this.loadData();
    },

    async loadDataNiveles() {
      this.itemsNiveles = await this.loadNiveles();
      if (this.itemsNiveles.length > 0) {
        this.loadNivelSelect();
      }
    },

    async loadNiveles() {
      return await axios
        .get("/reportes/niveles")
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    loadNivelSelect() {
      let niv = [];
      this.itemsNiveles.forEach(function (c) {
        let index = niv.findIndex((x) => x.id == c.id);
        if (index === -1) {
          if (c.id != null && c.id != "") {
            niv.push({ name: c.descripcion, code: c.id });
          }
        }
      });
      this.nivelSelect = niv;
    },

    nivelName() {
      let nivel = this.nivelValue;
      let encontrar = this.itemsNiveles.find(function (x) {
        //return x.codNivelAce==nivel;
        return x.id == nivel;
      });
      return encontrar.descripcion;
    },

    clear() {
      this.nivelValue = null;
      this.proveedorValue = null;
      this.periodoValue = new Date().getFullYear();
      this.loadData();
      this.graficaRegular = false;
    },

    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },

    // dsoto 21-12-2022
    async proveedores() {
      this.itemsProveedor = [];
      this.itemsProveedor = await this.loadProveedor();

      if (this.itemsProveedor.length > 0) {
        this.loadProveedorSelect();
      } else {
        this.showAlert = true;
      }
    },

    async loadProveedor() {
      let proceso = "APLICACION";

      return await axios
        //.get("/proveedores")
        .get("/proveedoresProceso/" + proceso)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadProveedorSelect() {
      let niv = [];
      this.itemsProveedor.forEach(function (c) {
        let index = niv.findIndex((x) => x.id == c.id);
        console.log(c.razonSocial);
        console.log(c.id);

        if (index === -1) {
          if (c.id != null && c.id != "") {
            niv.push({ nombre: c.razonSocial, code: c.id });
          }
        }
      });
      this.proveedorSelect = niv;
    },
    // dsoto 21-12-2022

    // dsoto 28-12-2022
    downloadData() {
      //alert("este si");
      //this.dialogLoading = true;
      let filename = "Reporte_Cursos_DS.xlsx";

      //alert(this.nivelValue);
      //alert(this.periodoValue);
      //alert(this.proveedorValue);

      if (this.proveedorValue == null) {
        this.proveedorValue = 0;
      }

      axios({
        url:
          "/reportes/DSExcel/" +
          this.nivelValue +
          "/" +
          this.periodoValue +
          "/" +
          this.proveedorValue,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
